import React from 'react';

function ScrollLogo() {
  return (
    <div style={styles.scrollContainer}>
      <div style={styles.logoTrack}>
        {/* Duplicamos los logos para crear un efecto de bucle continuo */}
        {[...Array(2)].map((_, index) => (
          <React.Fragment key={index}>
            <img src="/logos/meta.png" alt="Meta logo" style={styles.logoImage} />
            <img src="/logos/lacaixa.png" alt="La Caixa logo" style={styles.logoImage} />
            <img src="/logos/autodesk.png" alt="Autodesk Logo" style={styles.logoImage} />
            <img src="/logos/zurich.png" alt="Zurich logo" style={styles.logoImage} />
            <img src="/logos/revolut.png" alt="Revolut logo" style={styles.logoImage} />
            <img src="/logos/apple.png" alt="Apple Logo" style={styles.logoImage} />
            <img src="/logos/accenture.png" alt="Accenture logo" style={styles.logoImage} />
            <img src="/logos/ingram.png" alt="Ingram Micro logo" style={styles.logoImage} />
            <img src="/logos/hbx.png" alt="HBX Group logo" style={styles.logoImage} />
            <img src="/logos/puig.png" alt="Puig logo" style={styles.logoImage} />
            <img src="/logos/microsoft.png" alt="Microsoft logo" style={styles.logoImage} />
            <img src="/logos/telefonica.png" alt="Telefonica logo" style={styles.logoImage} />
            <img src="/logos/nttdata.png" alt="NTT Data logo" style={styles.logoImage} />
            <img src="/logos/vmware.png" alt="vmware logo" style={styles.logoImage} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

const styles = {
  scrollContainer: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    padding: '20px 0',
    overflow: 'hidden', // Ocultamos el contenido que se sale del contenedor
    position: 'relative',
  },
  logoTrack: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '40px',
    animation: 'scrollLeft 50s linear infinite', // Animación continua
  },
  logoImage: {
    height: '60px',
    width: 'auto',
  },
};

// Definimos los estilos globales para la animación
const styleSheet = document.styleSheets[0];
const keyframes = `
@keyframes scrollLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}`;
styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

export default ScrollLogo;